<template>
    <b-container>
        <b-form @submit="onSubmit">
            <div v-if="success" class="pt-4">
                <b-alert show variant="success">
                    <p>{{ $t("info.successgeneric") }}</p>
                </b-alert>
            </div>
            <div v-else>
                <b-alert show variant="info">
                    <b-row>
                        <b-col>
                            <div>
                                <strong>{{ $t("action.currentUserList") }}</strong> :
                            </div>
                            <ul v-if="currentUserList.length > 0">
                                <li v-for="(item) in currentUserList" v-bind:key="item.value.id">
                                    {{ item.text }}
                                </li>
                            </ul>
                        </b-col>
                    </b-row>
                </b-alert>
                <b-alert show variant="info">
                    <b-row>
                        <b-col>
                            <div>
                                <strong>{{ $t("title.taskAssignment") }}</strong> :
                            </div>
                            <b-form-select v-model="membersSelect" :options="membersList" multiple
                                size="sm"></b-form-select>
                            <div>
                                <small>&#9432; {{ $t("info.chooseMultiple") }}</small>
                            </div>
                        </b-col>
                    </b-row>
                </b-alert>

                <b-button class="mt-4 text-center" type="submit" variant="success" :disabled="disabled">{{
                    $t("action.confirmed") }}</b-button>
            </div>

            <div v-if="spinner" class="text-center">
                <b-spinner style="width: 3rem; height: 3rem" variant="success" label="Spinning"
                    disabled="labelStatus"></b-spinner>
            </div>

            <div v-if="error" class="pt-4">
                <b-alert show variant="danger">
                    <p>{{ error }}</p>
                </b-alert>
            </div>
        </b-form>
    </b-container>
</template>
  
<script>
import axios from "axios";
import { globalF } from "../../Helpers";

export default {
    mixins: [globalF],
    props: ["task", "modalid"],
    data: () => ({
        disabled: false,
        success: false,
        error: "",
        spinner: false,
        currentUserList: [],
        membersSelect: [],
        membersList: [],
    }),
    computed: {
        url: function () {
            let urls = this.$store.getters.getUrlsList;
            return urls[process.env.VUE_APP_WHERE].json;
        },
        assignments: function () {
            let arr = [];
            if (this.task.assignments) {
                arr = Object.entries(this.task.assignments);
            }
            return arr;
        }
    },
    mounted() {
        let token = this.getGlobalData("accessToken");
        let groupId = this.task.groupId;
        this.getMemberOf(token, groupId);
    },
    methods: {
        getGraphUserInfo() {
            this.error = "";
            let token = this.getGlobalData("accessToken");
            this.spinner = true;
            if (this.task.assignments) {
                let arr = Object.entries(this.task.assignments);
                for (let i = 0; i < arr.length; i++) {
                    let idUser = arr[i][0];
                    this.getUserById(idUser, token);
                }
            }
        },
        getUserById(idUser, token) {
            let graphEndpoint = `https://graph.microsoft.com/v1.0/users/${idUser}`;
            axios
                .get(graphEndpoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                })
                .then((response) => {
                    this.spinner = false;
                    this.userList.push(response.data);
                })
                .catch(() => {
                    this.error = this.$t("info.errorgeneric");
                    this.spinner = false;
                });
        },
        getMemberOf(token, groupId) {
            this.spinner = true;
            let graphEndpoint = `https://graph.microsoft.com/v1.0/groups/${groupId}/members`;
            axios
                .get(graphEndpoint, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        ConsistencyLevel: "eventual",
                    },
                })
                .then((response) => {
                    let membersList = response.data.value;
                    this.membersList = membersList.map((item) => {
                        return {
                            value: item,
                            text: item.displayName,
                        };
                    });

                    this.currentUserList = this.getCurrentUserList();

                    this.spinner = false;
                })
                .catch(() => {
                    this.spinner = false;
                    this.error = this.$t("info.errorgeneric");
                });
        },
        getCurrentUserList() {
            let arr = [];
            if (this.task.assignments) {
                let assignments = Object.entries(this.task.assignments);
                for (let i = 0; i < assignments.length; i++) {
                    let idUser = assignments[i][0];
                    let find = this.membersList.find(m => m.value.id === idUser);
                    if (find) {
                        arr.push(find);
                    }
                }
            }
            return arr;
        },
        getMemberAssignToTask() {
            let assignments = {};
            let memberSelect = this.membersSelect;
            let currentUserList = this.currentUserList;
    
            if (currentUserList.length > 0) {
                for (let i = 0; i < currentUserList.length; i++) {
                    Object.assign(assignments, {
                        [currentUserList[i].value.id]: null
                    });
                }
            }

            for (let i = 0; i < memberSelect.length; i++) {
                Object.assign(assignments, {
                    [memberSelect[i].id]: {
                        "@odata.type": "#microsoft.graph.plannerAssignment",
                        orderHint: " !",
                    },
                });
            }

            return assignments;
        },
        onSubmit(evt) {
            evt.preventDefault();
            this.error = "";

            if (this.membersSelect.length > 0) {
                this.spinner = true;
                this.disabled = true;

                let token = this.getGlobalData("accessToken");
                let etag = this.task["@odata.etag"];
                let taskId = this.task.id;

                let graphEndpoint = `https://graph.microsoft.com/v1.0/planner/tasks/${taskId}`;

                let obj = {
                    "assignments": this.getMemberAssignToTask()
                } 

                axios
                    .patch(graphEndpoint, obj, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                            Prefer: "return=representation",
                            "If-Match": etag
                        },
                    })
                    .then(() => {
                        this.$bvModal.hide(this.modalid);
                    })
                    .catch(() => {
                        this.spinner = false;
                        this.disabled = false;
                        this.error = this.$t("info.errorgeneric");
                    });
            }
            else {
                this.error = this.$t("info.chooseAtLeastOneMember");
            }
        },
    },
};
</script>
  